type FeatureName = 'i18n'

const LOCALSTORAGE_PREFIX = 'kFeat_'

/**
 * Used to do A/B tests with disruptive features and let QA test them even with all the code integrated.
 *
 * Just set true to your feature in localStorage from devTool
 *
 * i.e: localStorage.kFeat_multilanguage = true
 *
 * @param feat
 * @returns
 */
export const isEnabled = (feat: FeatureName) =>
  localStorage.getItem(`${LOCALSTORAGE_PREFIX}${feat}`) === 'true'

export const i18nSwitch = <T1, T2>(whenEnabled: T1, whenDisabled: T2) =>
  isEnabled('i18n') ? whenEnabled : whenDisabled
